import React from 'react';

const FirebaseNotConfiguredView: React.FC = () => {
  const codeSnippet = `
// firebaseConfig.ts

// 1. Firebase 콘솔(https://console.firebase.google.com/)로 이동합니다.
// 2. 프로젝트를 선택한 후, 왼쪽 상단의 톱니바퀴 아이콘을 클릭하고 '프로젝트 설정'으로 이동합니다.
// 3. '내 앱' 섹션에서 웹 앱을 선택하거나 새로 만듭니다.
// 4. 'Firebase SDK 스니펫' 섹션에서 '구성'을 선택합니다.
// 5. 아래 객체에 해당 값을 복사하여 붙여넣으세요.

export const firebaseConfig = {
  apiKey: "여기에-api-key를-붙여넣으세요",
  authDomain: "your-project-id.firebaseapp.com",
  projectId: "your-project-id",
  storageBucket: "your-project-id.appspot.com",
  messagingSenderId: "your-messaging-sender-id",
  appId: "your-app-id"
};
`;

  return (
    <div className="min-h-screen bg-[#1A1D2D] flex items-center justify-center p-4">
      <div className="w-full max-w-3xl bg-[#252A41] text-[#F0EAD6] rounded-lg shadow-xl p-8">
        <h1 className="text-3xl font-black text-center text-[#C0A062] mb-4">
          Firebase 설정이 필요합니다
        </h1>
        <p className="text-[#A9B1D6] text-center mb-6">
          앱을 실행하려면 Firebase 프로젝트 설정이 필요합니다. 이전의 환경 변수 방식이 불안정하여, 보다 안정적인 직접 설정 방식으로 변경되었습니다.
        </p>
        <div className="bg-[#1A1D2D] p-4 rounded-lg">
          <p className="text-[#A9B1D6] mb-2">
            프로젝트의 파일 탐색기에서 <code className="bg-gray-700 px-1 py-0.5 rounded text-yellow-300">firebaseConfig.ts</code> 파일을 찾아 아래 내용으로 수정해주세요.
          </p>
          <pre className="bg-black text-white p-4 rounded-md overflow-x-auto text-sm">
            <code>{codeSnippet}</code>
          </pre>
        </div>
        <p className="text-center text-sm text-[#5F6B8E] mt-6">
          파일을 수정한 후, 페이지를 새로고침해주세요.
        </p>
      </div>
    </div>
  );
};

export default FirebaseNotConfiguredView;
